export const areYouSure = async function (message: string): Promise<boolean> {
	// TODO: Replace by a pretty custom alert box
	return window.confirm(message);
}
